import React from "react";
import { Box, Typography, Drawer, Stack, Divider, IconButton, CircularProgress } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InventoryIcon from "@mui/icons-material/Inventory";
import { DetalleTraspaso } from "../ui";

/**
 * Drawer que muestra el detalle de un traspaso
 */
export default function DrawerDetalle({ open, onClose, detalle, loading, onMarcarTraspasado }) {
    return (
        <Drawer anchor="right" open={open} onClose={onClose}>
            <Box sx={{ width: { xs: "100vw", md: 520 }, p: { xs: 2, sm: 3 } }}>
                {/* Header */}
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ mb: 2 }}
                >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                        <Box
                            sx={{
                                width: 40,
                                height: 40,
                                borderRadius: "50%",
                                backgroundColor: "#fee",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: 0,
                            }}
                        >
                            <InventoryIcon sx={{ color: "#cc071e", fontSize: 22 }} />
                        </Box>
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 700,
                                color: "#212529",
                                fontSize: { xs: "1.1rem", sm: "1.25rem" },
                            }}
                        >
                            Detalle traspaso
                        </Typography>
                    </Box>
                    <IconButton
                        onClick={onClose}
                        size="small"
                        sx={{
                            color: "#6c757d",
                            "&:hover": {
                                backgroundColor: "rgba(0,0,0,0.04)",
                            },
                        }}
                    >
                        <CloseIcon sx={{ fontSize: 24 }} />
                    </IconButton>
                </Stack>

                <Divider sx={{ mb: 3 }} />

                {/* Content */}
                {loading ? (
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            minHeight: "300px",
                        }}
                    >
                        <Box sx={{ textAlign: "center" }}>
                            <CircularProgress sx={{ color: "#cc071e", mb: 2 }} />
                            <Typography sx={{ color: "#6c757d", fontSize: 14 }}>
                                Cargando detalle...
                            </Typography>
                        </Box>
                    </Box>
                ) : !detalle ? (
                    <Typography variant="body2" sx={{ color: "#6c757d", textAlign: "center", py: 6 }}>
                        Sin datos.
                    </Typography>
                ) : (
                    <DetalleTraspaso
                        detalle={detalle}
                        onMarcarTraspasado={onMarcarTraspasado}
                    />
                )}
            </Box>
        </Drawer>
    );
}
